export class Pacote {
    public id: Number
    public dataCriacao: Date
    public recursos: Recurso[]
}

class Recurso {
    public id: Number
    public descricao: String
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/core/pacote.model.ts